import { allProducts } from './productsMenuConfig';

export const navItems = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services', megaMenu: true },
  { label: 'Products', href: '/products', megaMenu: true },
  { label: 'About', href: '/about' },
  { label: 'Free Tools', href: '/free-tools' },
  { label: 'Resources', href: '/resources' },
  { label: 'Contact', href: '/contact' },
];

// Assessment tools all live under the "Free Tools" hub.
const freeToolRoutes = [
  '/free-tools',
  '/nist-csf-assessment',
  '/nist-ai-rmf-assessment',
  '/security-maturity-assessment',
  '/risk-assessment',
];

const serviceRoutes = ['/services', '/cybersecurity', '/managed-it', '/development'];

export function getNavActiveIndex(pathname) {
  const directIndex = navItems.findIndex((item) => item.href === pathname);
  if (directIndex >= 0) return directIndex;

  if (serviceRoutes.includes(pathname) || pathname.startsWith('/services/')) {
    return navItems.findIndex((item) => item.label === 'Services');
  }

  if (pathname.startsWith('/products') || allProducts.some((p) => p.href === pathname)) {
    return navItems.findIndex((item) => item.label === 'Products');
  }

  if (freeToolRoutes.includes(pathname)) {
    return navItems.findIndex((item) => item.label === 'Free Tools');
  }

  // Articles live under /blog/:slug but belong to the Resources hub.
  if (pathname.startsWith('/resources') || pathname.startsWith('/blog')) {
    return navItems.findIndex((item) => item.label === 'Resources');
  }

  return 0;
}
